export default "__VITE_ASSET__b2ed8a16__"